/**
 * TEST REPORT — page counter
 * ----------------------------------------------------------------------------------------------------------------
 * Updates "X/Y pages" as the report page carousel scrolls. Listens for the theme's own "scrollend" event
 * (assets/theme.js's <scroll-carousel> dispatches this itself — Safari doesn't fire the native one reliably,
 * so relying on the theme's dispatch instead of the browser's own event is what makes this actually work
 * everywhere), plus a debounced scroll listener for snappier updates while dragging.
 */
(() => {
  function init(carousel) {
    const section = carousel.closest('[id^="shopify-section-"]');
    if (!section) return;

    const currentEl = section.querySelector('[data-test-report-current]');
    const pages = Array.from(carousel.querySelectorAll('.test-report__page'));
    if (!currentEl || pages.length === 0) return;

    let scrollTimeout;

    function update() {
      const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
      const clamped = Math.max(0, Math.min(index, pages.length - 1));
      currentEl.textContent = String(clamped + 1);
    }

    carousel.addEventListener('scrollend', update);
    carousel.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(update, 100);
    });

    update();
  }

  document.querySelectorAll('[data-test-report-pages]').forEach(init);
})();
